//import event_tracking_items from './GA_tracking_constants.json';
import UrlMappedConstants from '../config/GA_Tracking_IDS.json';
import ReactGA from 'react-ga';
import $ from 'jquery';
import HmEventRegistry from './../model/HmEventRegistry';
import debounce from 'lodash/debounce';

var GoogleAnalytics = function(){
	
	var debounce_google_analytics_event_trigger=debounce(google_analytics_event_trigger,10);
	function getInitializeId(pathname){
		//console.warn("UrlMappedConstants ",UrlMappedConstants);
		if(UrlMappedConstants[pathname]!=undefined && UrlMappedConstants[pathname]!=null){
			return UrlMappedConstants[pathname];
		}
		
		return UrlMappedConstants.defaultId;
		
	}
	function google_analytics_event_trigger(event_action, event_category, event_label){
		var pathname = getGAMappedIds();//getpathname();
		var initializerId = getInitializeId(pathname);
		var defaultId = UrlMappedConstants["defaultId"];
	    if(event_action!=null && event_action!= undefined){
	      var event_ga = {"eventAction": event_action };
	      var event_ga_default = {"action":event_action}
	     
	      if(event_category!=NaN && event_category !=undefined && event_category!=null && event_category!=''){
	        event_ga['eventCategory'] = event_category;
	        event_ga_default['category'] = event_ga['eventCategory'];
	      }
	      if(event_label!=NaN && event_label !=undefined && event_label!=null && event_label!=''){
	        event_ga['eventLabel'] = event_label;
	        event_ga_default['label'] = event_label;
	      }
	      if(initializerId!=defaultId){
	    	  ReactGA.ga(pathname+".send","event",event_ga);
	      }
	      ReactGA.ga("send","event",event_ga);
	    }
	    return
	  }
	
	function data_ga(value){
		if(value == null || value == undefined){
			return;
		}
		var escaped_value = value.replace(/\s+/g, '');
	     escaped_value = escaped_value.toLowerCase();
	     try{
	    	//  if(event_tracking_items.hasOwnProperty(escaped_value)){
	        //      var value_ga = event_tracking_items[escaped_value];
	        //      debounce_google_analytics_event_trigger(value, value_ga['event_category'], value_ga['event_label']);
	        //    }else{
	        // 	   debounce_google_analytics_event_trigger(value);
			//    }
			debounce_google_analytics_event_trigger(getEventCategory(),getEventAction(value),getEventLabel(value));
	     }catch(e){
	    	 console.log(e);
	    	 debounce_google_analytics_event_trigger(value);
	     }
	}
	function getpathname(){
		var pathname = window.location.pathname;
		var pathname_arr = pathname.split("/");
		if(pathname_arr.length>1){
			pathname = pathname_arr[1].replace(/[^\w]/gi, '');
		}
		else{
			pathname = "default";
		}
		return pathname;
	}

	function getGAMappedIds(){
		let pathName = window.location.pathname;
		pathName = pathName.substring(1,pathName.length).replace(/\//g,"-");
		return pathName;
	}

	function getEventCategory(){
		let pathName = window.location.pathname;
		pathName = pathName.substring(1,pathName.length).replace(/\//g,"-");

		if(window.ga_data && window.ga_data.role){
			pathName = window.ga_data.role + "-" + pathName;
		}
		return pathName;
	}

	function getEventAction(actionName){
		let pathName = getEventCategory();

		if(actionName){
			pathName += "-" + actionName;
		}
		return pathName;
	}

	function getEventLabel(actionName){
		return actionName;
	}

	return{
		
		GA: debounce(function(){try{
			
			var pathname = getGAMappedIds(); //getpathname();
			var initializerId = getInitializeId(pathname);
			var defaultId = UrlMappedConstants["defaultId"];
			//console.warn(initializerId+"------"+defaultId+"---"+pathname);
		
			if(initializerId!=defaultId){
				//console.warn(initializerId+"---"+pathname);
				ReactGA.initialize([{trackingId:initializerId ,gaOptions:{name:pathname}}, {trackingId:initializerId}]);
				//ReactGA.ga('create', initializerId,'auto' , pathname);
				ReactGA.ga(pathname+'.send', {'page': pathname,"hitType":"pageview"});
				
			}else{
				ReactGA.initialize([{trackingId:defaultId}]);
			}
			//ReactGA.ga('set', 'trackingId', initializerId);
			ReactGA.ga('set', 'location', window.location.href);
			ReactGA.pageview(pathname + window.location.search);
			//ReactGA.pageview("default.send", window.location.pathname + window.location.search);
			
		
		}catch(e){
			return
		}},150
		
		),
		GAEvent: debounce(function(){
			$('[data-ga]').unbind("click");
			$('[data-ga]').click(function(){
				var value = $(this).attr('data-ga');
				data_ga(value);
			});
			$('[data-hover-ga]').unbind("hover");
			$('[data-hover-ga]').hover(function(){
				var value = $(this).attr('data-hover-ga');
				data_ga(value);
			});
			$('[data-p-ga]').unbind("click");
			$('[data-p-ga]').click(function(event){
			    var element = event.target;
			    while($(element)!=$(this)){
			      if($(element).attr('data-ga')!=undefined && $(element).attr('data-ga')!=NaN && $(element).attr('data-ga')!= null ){
			        var value = $(element).attr('data-ga');
			        var escaped_value = value.replace(/\s+/g, '');
			        escaped_value = escaped_value.toLowerCase();
			        try{
			        //   if(event_tracking_items.hasOwnProperty(escaped_value)){
			        //     var value_ga = event_tracking_items[escaped_value];
			        //     debounce_google_analytics_event_trigger(value, value_ga['event_category'], value_ga['event_label']);
			        //   }else{
			        // 	  debounce_google_analytics_event_trigger(value);
					//   }
					  debounce_google_analytics_event_trigger(getEventCategory(),getEventAction(value),getEventLabel(value));
			        }catch(e){
			        	debounce_google_analytics_event_trigger(value);
			          return
			        }
			        return
			      }else if(element!=null){
			        element = element.parentNode;
			      }else{
			    	  return
			      }
			    }
			 
			  });
		}, 100)
	
	}
}();
export default GoogleAnalytics;

HmEventRegistry.registerEvent("INITIATE_GA",function(store){
	GoogleAnalytics.GA();
});
HmEventRegistry.registerEvent("INITIATE_GA_EVENT",function(store){
	GoogleAnalytics.GAEvent();
});


// WEBPACK FOOTER //
// ./src/util/Ga.js